'use client';

import { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import BrochureRequestFormFrench from './BrochureRequestFormFrench';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  const [isBrochureFormOpen, setIsBrochureFormOpen] = useState(false);

  return (
    <section className={`relative overflow-hidden ${className}`}>
      {/* Dynamic Eiffel Tower Cityscape Background */}
      <div className="absolute inset-0">
        <AppImage
          src="/assets/images/paris_cityscape_clean_dusk.png"
          alt="Tour Eiffel et paysage urbain au crépuscule avec skyline moderne de Paris"
          className="w-full h-full object-cover" />

        {/* Premium Dark Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/40 to-black/60"></div>
      </div>

      {/* Content Container */}
      <div className="relative w-full max-w-[1600px] mx-auto px-8 lg:px-20 pt-32 pb-24 lg:pt-44 lg:pb-32">

        {/* Premium Typography with Playfair Display */}
        <div className="mb-12 lg:mb-16">
          <h1
            className="font-serif text-[3rem] leading-[1.05] lg:text-[5rem] lg:leading-[1.05] xl:text-[6.5rem] xl:leading-[1.05] font-bold tracking-[0.02em] text-white"
            style={{ fontFamily: '"Playfair Display", serif' }}>Arbitrage International & Négociation


          </h1>

          {/* Thin Brass Accent Line */}
          <div className="relative mt-8 lg:mt-10">
            <div className="w-24 h-[1px] bg-[#A47C48]"></div>
          </div>

          {/* Refined Subtitle */}
          <p className="mt-8 text-base lg:text-lg font-normal tracking-normal text-[#F4F1EA]/90 max-w-2xl text-justify">Cabinet dédié à l'arbitrage international et à la négociation, offrant des équipes sur mesure d'excellence, multi-juridictionnelles, composées d'avocats et d'experts top tier.

          </p>
        </div>

        {/* Refined Premium Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 lg:gap-6">
          <button
            onClick={() => setIsBrochureFormOpen(true)}
            className="px-8 py-4 bg-[#A47C48] text-[#F4F1EA] border border-[#A47C48] font-medium tracking-wide transition-all duration-300 hover:bg-[#F4F1EA] hover:text-[#0E3B3C] hover:border-[#A47C48]">

            Demander la Brochure
          </button>
        </div>
      </div>

      {/* Brochure Request Form Modal */}
      <BrochureRequestFormFrench
        isOpen={isBrochureFormOpen}
        onClose={() => setIsBrochureFormOpen(false)} />

    </section>);

};

export default HeroSection;